module.exports = __webpack_public_path__ + "img/zbrush.a0442b9c.svg";